import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid } from '@mui/material';
import CommonTable from 'components/commonTable/CommonTable';
import ComplianceUpload from './ComplianceUpload';
import { useLocation } from 'react-router-dom';
import CommonFilter from 'components/commonFilter/CommonFilter';
import SearchBar from 'components/commonSearch/SearchBar';
import Loader from 'components/loader/Loader';

function ComplianceTab(props) {
  const { value,handleChangePage,handleChangeRowsPerPage,page,rowsPerPage } = props;
  
  const [showTabs, setShowTabs] = useState(true); // State to control the visibility of the tabs

  const role = localStorage.getItem('role');
  const location = useLocation();

  useEffect(() => {
    // Check if the "upload" query parameter exists in the URL
    const params = new URLSearchParams(location.search);
    const uploadParam = params.get('upload');

    if (uploadParam === 'true') {
      // If the "upload" query parameter is set to true, hide the tab section
      setShowTabs(false);
    } else {
      setShowTabs(true);
    }
  }, [location.search]);
 
  const handleChange = (event, newValue) => {
    props?.handleChange(newValue);
  };
  
  

  return (
    <Grid container>
      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle">
          {showTabs && ( // Conditionally render the tabs section based on the showTabs state
            <TabContext value={value}>
              <Grid
                container
                className="tabBoxStyle"
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <TabList
                    className="minHeight32"
                    onChange={handleChange}
                    aria-label="lab API tabs example"TabIndicatorProps={{
                      style: { backgroundColor: 'white' }, // Replace 'none' with your desired color
                    }}
                  >
                    {/* {role !== 'vendorCompany' && role !== 'subVendorCompany' &&(
                      <Tab label="Vendor" value="1" className="tabStyle" />
                    )} */}
                    {role !== 'subVendorCompany' && (
                    <Tab label="Sub-Vendor" value="2" className="tabStyle" />
                    )}
                    <Tab label="Driver" value="3" className="tabStyle" />
                    <Tab label="Vehicle" value="4" className="tabStyle" />
                    {/* remove self compliance for vendor app ---vendorCompany */}
                   {role !== 'adminCompany' && role !== 'vendorCompany' &&( <Tab label="Self" value="5" className="tabStyle" />)}
                    
                  </TabList>
                </Grid>
                {value !=='5' && 
                <Grid 
                  item
                  container
                  xs={6}
                  spacing={1}
                  direction=''
                  justifyContent='flex-end'
                  alignItems='center'
                >
                  <Grid item>
                    <SearchBar onSearch={props?.onSearch}/>
                  </Grid>
                  <Grid item className="">
                    <CommonFilter defaultStatus={props.defaultStatus} filterdata={props?.filterdata} onFilterChange={props?.onFilterChange}
                    onRestFilter={props?.onRestFilter}/>
                  </Grid>
                </Grid>}
              </Grid>
              {/* For admin tabpanel ---vendorCompany */}
              {/* <TabPanel
                value="1"
                sx={{ width: '100%' }}
                className="vendotTable"
              >
                <CommonTable
                  data={props?.tableData}
                  onClickTableVendor={props?.onClickTableVendor}
                  handleChangePage={props?.handleChangePage}
                  handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
                  page={props?.page}
                  rowsPerPage={props?.rowsPerPage}
                />
              </TabPanel> */}
              <TabPanel value="2" className="vendotTable tabPanelStyle">
                {props?.loader? 
                  <Loader/> 
                  :
                  <CommonTable
                    data={props?.tableData}
                    onClickTableVendor={props?.onClickTableVendor}
                    handleChangePage={props?.handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={props?.page}
                    rowsPerPage={props?.rowsPerPage}
                    isClickable = {true}
                  />
                }
              </TabPanel>
              <TabPanel value="3" className="vendotTable tabPanelStyle">
                {props?.loader? 
                  <Loader/> 
                  :
                  <CommonTable
                    data={props?.tableData}
                    onClickTableVendor={props?.onClickTableVendor}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable = {true}
                  />
                }
              </TabPanel>
              <TabPanel value="4" className="vendotTable tabPanelStyle">
                {props?.loader? 
                  <Loader/> 
                  :
                  <CommonTable
                    data={props?.tableData}
                    onClickTableVendor={props?.onClickTableVendor}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable = {true}
                  />
                }
              </TabPanel>
              <TabPanel value="5" className='tabPanelStyle'>
                <ComplianceUpload  tabName={'Self'}/>
              </TabPanel>
            </TabContext>
          )}
          {!showTabs && <ComplianceUpload />}{' '}
          {/* Show only the ComplianceUpload component */}
        </Box>
      </Grid>
    </Grid>
  );
}

export default ComplianceTab;
